module.exports = __webpack_public_path__ + "static/media/level-elementary.67d34858.png";